/**
 *  [2022] Zettant Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Zettant Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Zettant Incorporated and its
 * suppliers and may be covered by Japan. and Foreign Patents,
 * patents in process, and are protected by trade secret or
 * copyright law. Dissemination of this information or
 * reproduction of this material is strictly forbidden unless
 * prior written permission is obtained from Zettant Incorporated.
 */

/**
 * :ZNOTE:
 * tag: global,state,アプリ全体,共有パラメータ
 * note:
 *  - 全てのComponent(MainLayoutの子component)で共有できるstate（globalState）を定義する
 *  - MainLayoutでprovideする
 * sample:
 *  - src/layouts/MainLayoutWithMenus.vue
 * :ZNOTE:
 */

/**
 *
 */

import {reactive, InjectionKey} from 'vue';
import {customState, ICustomGlobalState} from '@projectRoot/appLogic/customGlobalState';
import {sleep} from '@zettant/commonUtils';

interface IBaseGlobalState {
  appTitle: string;   // 画面上部に表示するアプリタイトル
  loading: boolean;   // MainLayoutXXXXに埋め込まれたv-show="globalState.loading"を制御する
  loadingMessage: string|undefined;
  drawerOpen: boolean;  // メニューを開いているかどうか
  drawerNoShow: boolean;  // メニューを表示しないかどうか(trueならボタンを表示しない)
}

const defaultState: IBaseGlobalState = {
  appTitle: '',
  loading: false,
  loadingMessage: '',
  drawerOpen: false,
  drawerNoShow: false,
};

export type IGlobalState = IBaseGlobalState & ICustomGlobalState;

let singleGlobalState: any;  // TODO: 型定義

const _create = () => {
  const globalState = reactive<IGlobalState>({...defaultState, ...customState});
  let preferenceCallback: () => void;

  const showLoading = async (message?: string) => {
    globalState.loading = true;
    globalState.loadingMessage = message;
    await sleep(10);  // この10msを入れることでほぼ確実にくるくるが表示される
  };
  const removeLoading = () => {
    globalState.loading = false;
    globalState.loadingMessage = undefined;
  };
  const setCallbackOnBackFromPreferenceManu = (func: any) => preferenceCallback = func;
  const callbackOnBackFromPreferenceMenu = () => {
    if (preferenceCallback) preferenceCallback();
  };

  const setAppTitle = (title: string) => globalState.appTitle = title;

  return {
    globalState,
    showLoading,
    removeLoading,
    setCallbackOnBackFromPreferenceManu,
    callbackOnBackFromPreferenceMenu,
    setAppTitle,
  };
};

export function useGlobalState() {
  singleGlobalState = _create();
  return singleGlobalState;
}

export const getGlobalStateObject = () => {
  if (!singleGlobalState) {
    singleGlobalState = _create();
  }
  return singleGlobalState;
};

export const globalStateKey: InjectionKey<any> = Symbol('globalState');
